import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(authless)/signup/")({
  beforeLoad: () => {
    throw redirect({
      to: "/signup/distributor",
    });
  },
});
